import React from 'react'
import Header from './Header'
import SideNavBar from './SideNavBar'

class Home extends React.Component {
  render() {
    return (
      <div
        id="pcoded"
        className="pcoded"
      >
        <div className="pcoded-overlay-box"></div>
        <div className="pcoded-container navbar-wrapper">
          <Header
            id="header-edit"
            className="header-edting"
          />
          {localStorage.getItem('waves_ad') !== 'Captain' ? (
            <div className="pcoded-main-container">
              <div className="pcoded-wrapper">
                <SideNavBar />
                <div
                  className="pcoded-content"
                  id="admin_content"
                >
                  {this.props.children}
                </div>
              </div>
            </div>
          ) : (
            <div className="pcoded-main-container">
              <SideNavBar />
              <div
                className="pcoded-content"
                id="admin_content"
              >
                {this.props.children}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Home
